import React from 'react';
import { Link } from 'react-router-dom';

export default function Button({ children, to, href, variant = 'primary', className = '', ...props }) {
  const baseStyle = "inline-flex items-center justify-center px-6 py-3.5 rounded-sm font-semibold transition-all duration-300 tracking-wide uppercase text-sm";
  
  const variants = {
    primary: "bg-blue-600 text-white hover:bg-blue-700 shadow-[0_4px_20px_rgba(37,99,235,0.3)] hover:shadow-[0_4px_25px_rgba(37,99,235,0.5)] transform hover:-translate-y-0.5",
    outline: "border-2 border-slate-700 text-white hover:border-blue-500 hover:text-blue-500 hover:bg-slate-900",
    white: "bg-white text-slate-950 hover:bg-slate-100",
  };

  const classes = `${baseStyle} ${variants[variant]} ${className}`;

  if (to) {
    return <Link to={to} className={classes} {...props}>{children}</Link>;
  }
  if (href) {
    return <a href={href} className={classes} {...props}>{children}</a>;
  }
  
  return <button className={classes} {...props}>{children}</button>;
}